
export default function Contact() {
  return (
    <section id="contact" className="bg-gray-900">
      <div className="max-w-[1400px] mx-auto px-20 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-16">
          <div className="space-y-8">
            <div className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/1e40b28d-4eaf-43eb-b7a-5b4121cbbda3.png" 
                alt="BOMAG Logo" 
                className="w-12 h-12 object-contain"
              />
              <h3 className="text-4xl font-bold text-white">BOMAG d.o.o.</h3>
            </div>
            <p className="text-lg text-gray-400 leading-relaxed max-w-md">
              A team of experts developing modern applications for the iOS platform. Enhancing user experience and improving the security of mobile devices.
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-700 text-gray-400 hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-700 text-gray-400 hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-700 text-gray-400 hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="w-12 h-12 flex items-center justify-center rounded-full border-2 border-gray-700 text-gray-400 hover:border-teal-500 hover:text-teal-500 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          <div className="space-y-10">
            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-600/20 rounded-lg">
                  <i className="ri-map-pin-line text-xl text-teal-400"></i>
                </div>
                <h4 className="text-xs uppercase tracking-widest text-white font-semibold whitespace-nowrap">Address</h4>
              </div>
              <div className="pl-13 space-y-1">
                <p className="text-base text-gray-400">Ob zeleznici 14</p>
                <p className="text-base text-gray-400">Ljubljana, 1000</p>
                <p className="text-base text-gray-400">Slovenia</p>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-600/20 rounded-lg">
                  <i className="ri-phone-line text-xl text-teal-400"></i>
                </div>
                <h4 className="text-xs uppercase tracking-widest text-white font-semibold whitespace-nowrap">Phone</h4>
              </div>
              <div className="pl-13">
                <a href="tel:+18124871091" className="text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  +1 8124871091
                </a>
              </div>
            </div>

            <div className="space-y-4">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-600/20 rounded-lg">
                  <i className="ri-mail-line text-xl text-teal-400"></i>
                </div>
                <h4 className="text-xs uppercase tracking-widest text-white font-semibold whitespace-nowrap">Email</h4>
              </div>
              <div className="pl-13">
                <a href="mailto:info@bomagdoo.com" className="text-base text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  info@bomagdoo.com
                </a>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="w-full h-[400px] rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/d97980cd4006125c59ac32f7ad91ef8d.jpg"
                alt="BOMAG Office"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-gray-800">
        <div className="max-w-[1400px] mx-auto px-20 py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <p className="text-sm text-gray-500">
              © 2025 BOMAG d.o.o. All rights reserved
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-sm text-gray-500 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="#" className="text-sm text-gray-500 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                Terms of Service
              </a>
              <a href="#" className="text-sm text-gray-500 hover:text-teal-400 transition-colors cursor-pointer whitespace-nowrap">
                Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}